<template>
    <!-- 弹窗遮罩层 -->
    <div v-if="maskLayerVisible"
        class="mask-layer">
        <!-- 关闭遮罩层按钮，活动未进行时显示 -->
        <div v-if="activityNoRunningTips.length !== 0 && popupType === ''"
            class="close-page"
            @click="closeMask">
            <img class="close-page-img"
                src="../../../../../../../../static/runtime/images/magic/timedDraw/close.png">
        </div>
        <!-- 活动未进行中时的提示 -->
        <div v-if="activityNoRunningTips.length !== 0 && popupType === ''"
            class="page-content">
            <div class="activity-finished">{{ activityNoRunningTips }}</div>
        </div>
        <!-- 全部中奖弹窗样式，总是先显示该弹窗 -->
        <general-award-view ref="generalAwardViewRef"
            :activityInfoObj="activityInfoObj"
            :isInMiniProgram="isInMiniProgram"
            :currentAward="currentAward"
            :loginType="loginType"
            :popupType="popupType"
            @closeMask="closeMask"
            @GeneralAwardHandler="GeneralAwardHandler"></general-award-view>
        <!-- 实物+线上邮寄 -->
        <realOnlineMailingModal ref="realOnlineMailingModal"
            :awardObj="currentAward"
            :isCloseMethods="true"
            :overlayStyle="{'background-color': 'rgba(0,0,0,0)'}"
            @handleRealOnlineMailing="entityAwardOnlineHandler(arguments)"
            @closeEnd="closeMask"></realOnlineMailingModal>
        <!-- 实物+到店自提（直营店）、虚拟+线下核销发卡密、虚拟+线下核销、赠品券 -->
        <codeCancelAfterVerfication v-if="codeShow"
            ref="realShopNoAppointment"
            :awardObj="currentAward"
            :codeUrl="currentAward.writeOffCodeUrl"
            :writeOffCode="currentAward.writeOffCode"
            :overlayStyle="{'background-color': 'rgba(0,0,0,0)'}"
            :extendConfigFlag="currentAward.extendConfigFlag"
            :activationCode="currentAward.activationCode"
            :effectiveStartTime="currentAward.effectiveStartTime"
            :effectiveEndTime="currentAward.effectiveEndTime"
            @closeEnd="closeMask"
            @nextStep="nextStep"
            @getUsedFlag="getUsedFlag"></codeCancelAfterVerfication>
        <!-- 虚拟+线上兑换 -->
        <virtualOnline ref="virtualOnline"
            :userInfoList="userInfoList"
            :awardObj="currentAward"
            :isReceived="isReceived"
            @handleVirtualOnline="handleVirtualOnline(arguments)"
            @closeEnd="closeMask"
            @modalCancel="closeMask"
            @nextStep="nextStep"></virtualOnline>
    </div>
</template>
<script>
import { BigWheelConstants as BWC, NBBAwardPopupType } from '../../../common/global-variable';
import generalAwardView from './general-award-view.vue';
import realOnlineMailingModal from '../../../../../../../components/modal/real-online-mailing-modal.vue';
import codeCancelAfterVerfication from '../../../../../../../components/modal/code-cancel-after-verification.vue';
import virtualOnline from '../../../../dynamicAttr/modal/virtual-online.vue';

export default {
  name: 'MaskLayer',
  components: {
    generalAwardView,
    realOnlineMailingModal,
    codeCancelAfterVerfication,
    virtualOnline,
  },
  props: {
    maskLayerVisible: {
      type: Boolean,
      default: false,
    },
    activityStatus: {
      type: String,
      default: '',
    },
    // 接口queryActivityBigWheelActivityDetailH5返回的活动信息
    activityInfoObj: {
      type: Object,
      default: {},
    },
    // 当前中奖奖品
    currentAward: {
      type: Object,
      default: {},
    },
    // 弹窗展示奖品类型
    popupType: {
      type: String,
      default: '',
    },
    // 是否在小程序内
    isInMiniProgram: {
      type: Boolean,
      default: false,
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    isReceived: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BWC: BWC,
      NBBAwardPopupType: NBBAwardPopupType,
      // 用户信息列表，虚拟+线上兑换弹窗使用
      userInfoList: [],
      codeShow:false
    };
  },
  computed: {
    activityNoRunningTips() {
      const status = this.activityStatus;
      let res = '';
      if (status !== BWC.ActivityStatus.running) {
        switch (status) {
          case BWC.ActivityStatus.paused:
            res = '活动已暂停';
            break;
          case BWC.ActivityStatus.finished:
            res = '活动已结束';
            break;
          case BWC.ActivityStatus.notStarted:
            res = '活动未开始';
            break;
          default:
            res = '';
        }
      }
      return res;
    },
  },
  watch: {
    /**
     * 打开遮罩层时，进行弹窗处理
     * @param {Boolean} newVal
     */
    maskLayerVisible(newVal) {
      if (newVal) {
        this.popupTypeHandler(this.popupType);
      }
    },
  },
  methods: {
    closeMask() {
      this.$emit('closeMask');
      this.codeShow = false;
    },
    entityAwardOnlineHandler(data) {
      this.$emit('entityAwardOnlineHandler', data);
    },
    /**
     * 根据popupType进行弹窗
     * @param {NBBAwardPopupType} newVal
     */
    popupTypeHandler(newVal) {
      if (newVal !== '') {
        let refName = '';
        switch (newVal) {
          case NBBAwardPopupType.entityAwardOnline:
            refName = 'realOnlineMailingModal';
            break;
          case NBBAwardPopupType.virtualAwardOnline:
            refName = 'virtualOnline';
            break;
          case NBBAwardPopupType.entityAwardInStore:
            refName = 'realShopNoAppointment';
            break;
          case NBBAwardPopupType.virtualAwardOfflineCode:
            refName = 'realShopNoAppointment';
            break;
          case NBBAwardPopupType.virtualAwardOffline:
            refName = 'realShopNoAppointment';
            break;
          case NBBAwardPopupType.noAward:
            refName = 'generalAwardViewRef';
            break;
          case NBBAwardPopupType.accumulatePoints:
            refName = 'generalAwardViewRef';
            break;
          case NBBAwardPopupType.coupon:
            refName = 'generalAwardViewRef';
            break;
          case NBBAwardPopupType.voucher:
            refName = 'generalAwardViewRef';
            break;
          case NBBAwardPopupType.giftCoupon:
            refName = 'realShopNoAppointment';
            break;
        }
        if (refName !== '') {
          // 虚拟线上兑换
          if (newVal === NBBAwardPopupType.virtualAwardOnline) {
            this.userInfoList = this.currentAward.userInfoList || [];
          }
          this.$nextTick(() => {
            if(refName === 'realShopNoAppointment'){
              this.codeShow = true
            }else{
              if(refName === 'generalAwardViewRef'){
                this.$refs[refName].openModel({ 
                  businessType: '9'
                });
              }else{
                this.$refs[refName].openModel();
              }
            }
          });
        }
      }
    },
    /**
     * 实物+到店自提领取处理
     * 虚拟奖品领取处理
     */
    nextStep() {
      this.$emit('nextStep', this.currentAward.jumpUrl, this.currentAward.jumpType);
      if (
        this.currentAward.rewardType === BWC.GoodsType.virtualAward &&
        (this.currentAward.collectionType === BWC.CollectionType.expressOrOnlineCheckOff ||
          this.currentAward.collectionType === BWC.CollectionType.checkOffStrCode)
      ) {
        return;
      }
      this.closeMask();
    },
    getUsedFlag() {
      this.$emit('getUsedFlag');
    },
    handleVirtualOnline(data) {
      this.$emit('virtualOnlineHandler', data);
    },
    GeneralAwardHandler() {
      this.$emit('GeneralAwardHandler');
    },
  },
};
</script>

<style lang="scss" scoped>
.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
  z-index: 1000;
  .close-page {
    position: absolute;
    right: 4.1%;
    top: 3.1%;
    width: 24px;
    height: 24px;
    border: 1px solid #ffffff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .close-page-img {
      width: 12px;
      height: 12px;
      filter: drop-shadow(0 0 white);
    }
  }
  .page-content {
    // margin-top: 27vh;
    width: 83%;
    text-align: center;
    font-family: HONORSansBrand-DemiBold;
    color: #ffffff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    .activity-finished {
      font-size: 30px;
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/mask-layer.vue